import { useEffect, useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import Loader from "../../../components/loader";
import Layout from "../../../layout/Layout";
import AppService from "../../../services/app.service";

const CreateOrEditNACEStandard = (props) => {
  const [formState, setFormState] = useState({
    label: "",
    description: "",
    loading: false,
  });
  const [, forceUpdate] = useState(0);
  const simpleValidator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );
  const [isEdit, setIsEdit] = useState(
    !props["match"].params.naceId
      ? { title: "Add", submitButtonTitle: "Create" }
      : {
          naceId: props["match"].params.naceId,
          title: "Edit",
          submitButtonTitle: "Update",
        }
  );

  const loadData = async () => {
    setFormState((prevState) => ({ ...prevState, loading: true }));
    let nace = {};
    if (isEdit.naceId) {
      nace = await AppService.get(isEdit.naceId, "naceStandard");
      setFormState((prevState) => ({ ...prevState, ...nace }));
    }
    setFormState((prevState) => ({ ...prevState, loading: false }));
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleChange = (event) => {
    const newState = { [event.target.name]: event.target.value };
    setFormState((prevState) => ({ ...prevState, ...newState }));
  };

  const submitForm = async (e) => {
    e.preventDefault();
    if (simpleValidator.current.allValid()) {
      setFormState((prevState) => ({ ...prevState, loading: true }));
      const nace = await AppService.submit(formState, "naceStandard");
      setFormState((prevState) => ({ ...prevState, loading: false }));
      if (nace.status === 200) {
        props.history.push("/nace-standards");
      } else {
        console.debug("Error while saving the Standard");
      }
    } else {
      simpleValidator.current.showMessages();
    }
  };
  const discardForm = (e) => {
    props.history.push("/nace-standards");
  };

  return (
    <div>
      <Layout
        title="NACE Standard Management"
        history={props.history}
        titleUrl="/nace-standards"
        subTitle={`${isEdit.title} NACE Standard`}
        activeNace={true}
        isStandardOpen={true}
        showBreadCrumb={true}
      >
        <section className="forms">
          <div className="container-fluid">
            <div className="row">
              {/* <!-- Horizontal Form--> */}
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header d-flex align-items-center">
                    <h3 className="sub-heading">
                      {isEdit.title} NACE Standard
                    </h3>
                  </div>
                  <div className="card-body">
                    <form className="form-horizontal" noValidate={true}>
                      <div className="form-group row">
                        <label className="col-sm-3 form-control-label required label">
                          Name
                        </label>
                        <div className="col-sm-9">
                          <input
                            name="label"
                            type="text"
                            maxLength={500}
                            placeholder="Standard Name"
                            className="form-control form-control-success fields-font"
                            value={formState.label}
                            onChange={(event) => handleChange(event)}
                            readOnly={isEdit.naceId}
                          />
                          {simpleValidator.current.message(
                            "name",
                            formState.label,
                            "required"
                          )}
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-sm-3 form-control-label required label">
                          Description
                        </label>
                        <div className="col-sm-9">
                          <textarea
                            name="description"
                            rows={5}
                            maxLength={5000}
                            placeholder="Description"
                            className="form-control form-control-success fields-font"
                            value={formState.description}
                            onChange={(event) => handleChange(event)}
                          />
                          {simpleValidator.current.message(
                            "description",
                            formState.description,
                            "required"
                          )}
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-9 offset-sm-3">
                          <button
                            type="submit"
                            onClick={submitForm}
                            className="btn btn-submit float-right buttons"
                          >
                            {isEdit.submitButtonTitle}
                          </button>
                          <button
                            type="button"
                            className="btn btn-cancel float-right buttons"
                            onClick={discardForm}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
      {formState.loading && (
        <div className="overlay">
          <Loader loading={formState.loading} />
        </div>
      )}
    </div>
  );
};

export default CreateOrEditNACEStandard;
